import classNames from 'classnames';

import lang from '../../../../lib/language';
import { useMarketTimer } from '../../../../lib/util/hooks/MarketTimerHook';

import { useIsMobile } from '../../../../hooks';

import styles from '../../HotGappers.module.scss';

const MarketRegularHoursTimer = (): JSX.Element => {
  const { timerValueAsString, isEnabled } = useMarketTimer('discover-hot-gappers');
  const { isMobile } = useIsMobile();

  if (!isEnabled) return <></>;

  return (
    <div className={classNames(styles.timerArea, {
      [styles.timerAreaMob]: isMobile,
    })}
    >
      <span className={styles.label}>{lang.gappersHottestMoversOpenTimer()}</span>
      <span className={styles.timer}>{timerValueAsString}</span>
    </div>
  );
};

export default MarketRegularHoursTimer;
